import Tracking from './tracking';

$(document).on('turbolinks:load', () => {
  const tracking = new Tracking();
  tracking.bindTrackers();
});
